import React, { Component } from "react";

import { withTimeRangeIntelligenceType } from "../../../shared/containers/containerTimeRangeIntelligenceType";

import IntelligenceGeneralData from "./intelligenceGeneralData";
import IntelligenceRouteData from "./intelligenceRouteData";
import MessagesData from "../../MessagesData/MessagesData";
import Chart from "../../Charts/Chart";
import IntelligencePlayer from "./intelligencePlayer";
import getDates from "../../../shared/services/date.service";
import { intelligenceTypes } from "./static.timeRangeIntelligenceTypes";
import styles from "./timeRangeIntelligenceTabs.module.scss";
import AnalisesSignalTree from "../../AnalisesSignalTree/AnalisesSignalTree";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withIntelligenceControl } from "../../../shared/containers/containerIntelligenceControl";
import IntelligenceVidioPlayer from "./IntelligenceVidioPlayer";
import { withChoosedCar } from "../../../shared/containers/containerChoosedCar";
import { withCars } from "../../../shared/containers/containerCars";

class TimeRangeIntelligenceTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generalDataState: {
        scroll: 0,
        checkIndex: 0,
      },
      routeDataState: {
        scroll: 0,
        selectDate: null,
        openDashboards: [],
      },
      messagesDataState: {
        scroll: 0,
        selectIndex: 0,
        selectPage: 1,
        selectDate: null,
        page: 1,
      },
    };
  }

  componentDidUpdate(prevProps) {
    const { listUnits, choosedCarId, intelligenceType, onChangeIntelligenceType } = this.props;

    if (intelligenceType === intelligenceTypes.videoPlayer.value) {
      const unit = listUnits.filter((x) => {
        return x.id === choosedCarId;
      })[0];

      if (unit.howenDevice === null) {
        onChangeIntelligenceType(intelligenceTypes.general.value);
      }
    }
  }

  setGeneralDataState(generalDataState) {
    this.setState({
      generalDataState: generalDataState,
    });
  }

  setRouteDataState(routeDataState) {
    this.setState({
      routeDataState: routeDataState,
    });
  }

  setMessagesSelectDateDataState(date) {
    const { messagesDataState, routeDataState } = this.state;

    messagesDataState.selectDate = getDates.getDateFormat7(date);
    routeDataState.selectDate = getDates.getDateFormat7(date);
    this.setState({
      messagesDataState: messagesDataState,
      routeDataState: routeDataState,
    });
  }

  setMessagesDataState(messagesDataState) {
    this.setState({
      messagesDataState: messagesDataState,
    });
  }

  getComponent = () => {
    const { intelligenceType, fullScreen } = this.props;
    const { generalDataState, routeDataState, messagesDataState } = this.state;

    switch (intelligenceType) {
      case intelligenceTypes.route.value:
        return (
          <IntelligenceRouteData
            onSetMessagesSelectDateDataState={this.setMessagesSelectDateDataState.bind(this)}
            onSetRouteDataState={this.setRouteDataState.bind(this)}
            routeDataState={routeDataState}
          />
        );
      case intelligenceTypes.messages.value:
        return (
          <MessagesData
            onSetMessagesSelectDateDataState={this.setMessagesSelectDateDataState.bind(this)}
            onSetMessagesData={this.setMessagesDataState.bind(this)}
            dataState={messagesDataState}
          />
        );
      case intelligenceTypes.chart.value:
        return <Chart height={fullScreen ? 400 : 200} />;
      case intelligenceTypes.player.value:
        return <IntelligencePlayer />;
      case intelligenceTypes.videoPlayer.value:
        return <IntelligenceVidioPlayer />;
      case intelligenceTypes.analiseSignal.value:
        return <AnalisesSignalTree />;
      default:
        return <IntelligenceGeneralData onSetGeneralDataState={this.setGeneralDataState.bind(this)} generalDataState={generalDataState} />;
    }
  };

  render() {
    const { onChangeIntelligenceType, intelligenceType, disabled, data, listUnits, choosedCarId } = this.props;

    const unit = listUnits.filter((x) => {
      return x.id === choosedCarId;
    })[0];

    return (
      <div className={styles.timeRangeIntelligenceTabs}>
        <div className={disabled ? styles.container_tabList_disabled : styles.container_tabList}>
          <TabsNavbar
            datas={Object.values(intelligenceTypes)}
            active={intelligenceType}
            handleClick={onChangeIntelligenceType}
            permissions={data.permissions}
            isVideoPlayer={unit !== undefined && unit.howenDevice !== undefined && unit.howenDevice !== null}
          />
        </div>
        <div className={styles.container_tabContent}>{this.getComponent()}</div>
      </div>
    );
  }
}

const TabsNavbar = (props) => {
  const { datas, active, handleClick, permissions, isVideoPlayer } = props;

  return datas.map((item, index) => {
    if (item.permission !== null && !permissions.includes(item.permission)) {
      return null;
    }

    if (!isVideoPlayer && item.value === intelligenceTypes.videoPlayer.value) {
      return null;
    }

    return (
      <div
        className={active === item.value ? styles.container_tab_active : styles.container_tab}
        key={index}
        onClick={active !== item.value ? handleClick.bind(this, item.value) : null}
      >
        <span>{item.title}</span>
      </div>
    );
  });
};

export default withCars(withChoosedCar(withIntelligenceControl(withAuth(withTimeRangeIntelligenceType(TimeRangeIntelligenceTabs)))));
